module.exports = __webpack_public_path__ + "static/media/oilseed.257af85f.jpg";